/* ══════════════════════════════════════════════════════════════════
   woo-campaign.js — Cyber / campañas (2026-10)

   Depende de window.WooCampaign, que define el script inline de
   sections/woo-campaign.liquid (sincrónico, antes de pintar).

   · Contadores [data-wc-countdown] (barra y hero), con cambio de fase
     automático a la hora exacta (sin recargar).
   · Swatches de tarjetas (wl-card, loop-most-loved, bbw-card): copian
     data-wc-* al precio Cyber de la tarjeta.
   · Enlace "Armar mi pack" de la ficha: agrega ?add=<variante actual>.
   · Carrito: botón "Convertir en pack".
   · Preview: marca el carrito con `_campana_preview` para que la
     Discount Function aplique la campaña en el checkout de prueba.

   Hook de prueba (consola):
     window.__wooCampaignNow = '2026-10-06T23:59:50-03:00'; WooCampaign.apply();
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var WC = window.WooCampaign;
  if (!WC) return;
  var C = WC.cfg;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ── Contadores ─────────────────────────────────────────────── */
  function target() {
    var ends = WC.phases[WC.phase];
    return ends && !isNaN(ends) ? Math.min(ends, WC.end) : WC.end;
  }

  function paint() {
    var left = Math.max(0, target() - WC.now());
    var sec = Math.floor(left / 1000);
    var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600);
    var m = Math.floor((sec % 3600) / 60), s = sec % 60;
    var short = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    var els = document.querySelectorAll('[data-wc-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-wc-format') === 'boxes') {
        var parts = { d: d, h: h, m: m, s: s };
        Object.keys(parts).forEach(function (k) {
          var p = el.querySelector('[data-cd="' + k + '"]');
          if (p) p.textContent = k === 'd' ? String(parts[k]) : pad(parts[k]);
        });
      } else {
        var prefix = el.getAttribute('data-wc-prefix') || 'Termina en ';
        el.textContent = prefix + short;
      }
    }
  }

  function tick() {
    WC.apply();
    paint();
  }
  tick();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });

  /* ── Swatches de tarjetas: precio Cyber de la variante elegida ─ */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-wc-now]');
    if (!sw || sw.closest('.wc-price')) return;
    var card = sw.closest('.loop-card, .bbw-card');
    if (!card) return;
    var prices = card.querySelectorAll('.wc-price');
    for (var i = 0; i < prices.length; i++) {
      var box = prices[i];
      if (box.hasAttribute('data-wc-cuota')) { box.textContent = sw.getAttribute('data-wc-cuota') || box.textContent; continue; }
      var now = box.querySelector('[data-wc-now]');
      var was = box.querySelector('[data-wc-was]');
      var pill = box.querySelector('[data-wc-pill]');
      if (now) now.textContent = sw.getAttribute('data-wc-now');
      if (was) was.textContent = sw.getAttribute('data-wc-was');
      if (pill) pill.textContent = sw.getAttribute('data-wc-pill');
    }
  }, true);

  /* ── Ficha: "Armar mi pack con este producto" ───────────────── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-wc-pack-link]');
    if (!a) return;
    var input = document.getElementById(a.getAttribute('data-input'));
    if (!input || !input.value) return;
    var url = new URL(a.getAttribute('href'), window.location.origin);
    url.searchParams.set('add', input.value);
    a.setAttribute('href', url.pathname + url.search);
  }, true);

  /* ── Carrito: convertir productos sueltos en pack ───────────── */
  var routes = window.routes || {};
  function refreshCart() {
    if (document.getElementById('main-cart-items')) { window.location.reload(); return Promise.resolve(); }
    var url = (routes.cart_url || '/cart') + '?section_id=cart-drawer';
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
        var a = document.querySelector(sel), b = doc.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wc-convert]');
    if (!btn) return;
    e.preventDefault();
    var lines;
    try { lines = JSON.parse(btn.getAttribute('data-wc-convert')); } catch (err) { return; }
    if (!lines || !lines.length) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Convirtiendo…';
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        // Liquid serializa "sin propiedades" como [] → normalizar a objeto
        var src = l.properties && !Array.isArray(l.properties) ? l.properties : {};
        var props = {};
        Object.keys(src).forEach(function (k) { props[k] = src[k]; });
        props._pack = 'arma-tu-pack';
        return fetch((routes.cart_change_url || '/cart/change') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: l.key, quantity: l.quantity, properties: props })
        }).then(function (r) { if (!r.ok) throw new Error('change'); });
      });
    });
    chain.then(refreshCart).catch(function () {
      btn.disabled = false;
      btn.textContent = 'No se pudo convertir — reintentar';
      setTimeout(function () { btn.textContent = label; }, 4000);
    });
  });

  /* ── Preview: marcar el carrito para la Discount Function ─────
     El token solo existe en el navegador de quien abrió el enlace de
     preview (localStorage); la function lo compara con el metafield. */
  function markCart() {
    var LS = null;
    try { LS = window['local' + 'Storage']; } catch (e) {}
    var tok = null;
    try { tok = LS ? LS.getItem('wc_preview') : null; } catch (e) {}
    var want = tok || '';
    /* Se compara contra el carrito REAL (no contra una marca local): el
       carrito puede cambiar de token, vaciarse o perder atributos. */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var has = (cart.attributes && cart.attributes._campana_preview) || '';
        if (has === want) return;
        if (!want && !has) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _campana_preview: want } })
        });
      }).catch(function () {});
  }
  markCart();
  document.addEventListener('wc:preview', markCart);
  if (WC.preview) document.addEventListener('cart:updated', markCart);
})();
